module.exports = __webpack_public_path__ + "static/img/nx.96bfa0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/scene-builder/textures/cubemap/home/nx.png
// module id = 666
// module chunks = 2